module.exports = __webpack_public_path__ + "static/media/student-summary-losebox.390ac0d5.png";